import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { createUrl, request } from 'app/utils';
import { Flex, Loading, Page, Section, Typography } from 'components';
import { JourneyProductAreaHero, JourneyVideoPlayer, ProductJourneyDashboardAreaFullResponse, useJourneys } from 'features/journeys';
import { useSchool } from 'features/school';
import Cards from 'features/dashboard-new/sheets/cards';
import { useMenu } from 'features/menu';

const Wrapper = styled(Flex)(({ theme }) => {
  return `
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    background-color: ${theme.colors.dark_350};
    align-items: flex-start;
  `;
});

const AreaDetails = () => {
  const [loading, setLoading] = useState(false);
  const { productSlug, journeyAreaUuid } = useParams();

  const { apiGatewayUrl } = useSchool();
  const { journeyAreaDetails, setJourneyAreaDetails, clearJourneyAreaDetails } = useJourneys();
  const { setBackPathname } = useMenu();

  const fetchAreaDetails = useCallback(() => {
    setLoading(true);

    request<ProductJourneyDashboardAreaFullResponse>({
      url: `/api/v1/School/Products/JourneyArea/${productSlug}/${journeyAreaUuid}`,
      method: 'get',
      baseURL: apiGatewayUrl,
    })
      .then(({ data }) => {
        setJourneyAreaDetails(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [productSlug, journeyAreaUuid]);

  useEffect(() => {
    setBackPathname(createUrl('journeys/details', [productSlug]));

    fetchAreaDetails();
  }, [productSlug, journeyAreaUuid]);

  useEffect(() => {
    clearJourneyAreaDetails();
  }, []);

  if (loading) return <Loading label="Por favor, aguarde." />;

  return (
    <Page title={journeyAreaDetails?.name}>
      <JourneyVideoPlayer />

      <Wrapper background={`url(${journeyAreaDetails?.coverImageUrl})`}>
        <Flex flexDirection="column" zIndex={5}>
          <JourneyProductAreaHero />
        </Flex>
      </Wrapper>

      <Flex bg="dark_350" pb={{ d: 10 }}>
        <Section>
          <Cards cards={journeyAreaDetails?.cards} journeyProductSlug={productSlug} />
        </Section>
      </Flex>

      {!!journeyAreaDetails?.practiceExams?.length && (
        <Flex bg="dark_350" pb={{ d: 10 }}>
          <Section flexDirection="column" flexGrow={0}>
            <Flex mb={2} alignItems="center" justifyContent="space-between">
              <Flex flexDirection="column">
                <Typography as="h2" type="type8" fontWeight="bold" color="white">
                  Simulados
                </Typography>
              </Flex>

              <Flex alignItems="center" flexGrow={0}></Flex>
            </Flex>

            <Cards cards={journeyAreaDetails?.practiceExams} />
          </Section>
        </Flex>
      )}

      {!!journeyAreaDetails?.liveMeetings?.length && (
        <Flex bg="dark_350" pb={{ d: 10 }}>
          <Section flexDirection="column" flexGrow={0}>
            <Flex mb={2} alignItems="center" justifyContent="space-between">
              <Flex flexDirection="column">
                <Typography as="h2" type="type8" fontWeight="bold" color="white">
                  Encontros ao-vivo
                </Typography>
              </Flex>

              <Flex alignItems="center" flexGrow={0}></Flex>
            </Flex>

            <Cards cards={journeyAreaDetails?.liveMeetings} journeyProductSlug={productSlug} />
          </Section>
        </Flex>
      )}
    </Page>
  );
};

export default AreaDetails;
